<template>
  <div class="rec-project-chat-section">
    <h3>
      {{ constants.RECENT_PROJECT_CHAT_TEXT }}
    </h3>
    <div class="rec-project-chat">
      <div class="rec-chat-box">
        <div class="rec-chat-left-row">
          <div class="rec-chat-user-img">
            <img src="@/assets/lems-v1/images/team-members/ashok.jpg" alt="" />
          </div>
          <div class="rec-chat-content">
            <div class="rec-chat-txt">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </div>
            <div class="rec-chat-time">Monday, January 22,2014 at 12:05 PM</div>
          </div>
        </div>
        <div class="rec-chat-left-row">
          <div class="rec-chat-user-img">
            <img src="@/assets/lems-v1/images/team-members/channi.jpg" alt="" />
          </div>
          <div class="rec-chat-content">
            <div class="rec-chat-txt">
              Quisque et diam ac ipsum elementum efficitur vitae eu odio.
            </div>
            <div class="rec-chat-time">Monday, January 22,2014 at 12:05 PM</div>
          </div>
        </div>
        <div class="rec-chat-left-row">
          <div class="rec-chat-user-img">
            <img src="@/assets/lems-v1/images/team-members/binod.jpg" alt="" />
          </div>
          <div class="rec-chat-content">
            <div class="rec-chat-imgs">
              <ul>
                <li>
                  <img
                    src="@/assets/lems-v1/images/chat-send-img-1.jpg"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="@/assets/lems-v1/images/chat-send-img-2.jpg"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="@/assets/lems-v1/images/chat-send-img-3.jpg"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="@/assets/lems-v1/images/chat-send-img-4.jpg"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="@/assets/lems-v1/images/chat-send-img-5.jpg"
                    alt=""
                  />
                </li>
                <li class="chat-last-imgs">
                  <span>5+</span>
                  <img
                    src="@/assets/lems-v1/images/chat-send-img-6.jpg"
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div class="rec-chat-time">Monday, January 22,2014 at 12:05 PM</div>
          </div>
        </div>
        <div class="rec-chat-right-row">
          <div class="rec-chat-content">
            <div class="rec-chat-gray-txt">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent
              a suscipit erat, vitae lobortis est.
            </div>
            <div class="rec-chat-time">Monday, January 22,2014 at 12:05 PM</div>
          </div>
        </div>
      </div>
    </div>
    <div class="see-all-btn">
      <a
        href="employee-chat.html"
        id="seeAllChatLink"
        class="v1-button-outline"
      >
        {{ constants.SEE_ALL_CHAT_LINK }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "ProjectRecentChats",
  data() {
    return {
      constants,
    };
  },
});
</script>
